import Cookies from "js-cookie";
import "element-ui/lib/theme-chalk/index.css";

//语言
export const setLang = (state, data) => {
  console.log("语言切换", data);
  state.local = data;
  localStorage.setItem("locale", data);
};

export const quitLogin = (state) => {
  state.userInfo = {};
  state.user = {};
  state.token = "";
  state.isLogin = false;
  Cookies.remove("user");

  Cookies.remove("token");
};

export const setUser = (state, data) => {
  let obj = {
    ...data,
  };
  state.user = obj;
  console.log(obj);
  console.log("setUser", JSON.stringify(obj).length);
  Cookies.set("user", JSON.stringify(obj), { expires: 7 });
};
export const setToken = (state, data) => {
  console.log("setToken", data);
  state.token = data;
  Cookies.set("token", data, { expires: 7 });
};



// WEBPACK FOOTER //
// ./src/store/mutations.js